import controller from './wf-state-todo.controller';
import template from './wf-state-todo.html';
import './wf-state-todo.scss';

export default {
	controller,
	template,
	bindings: {
		loading:      '=?',
		nb:           '=?',
		onDataLoaded: '&?',
	},
};
